import type { ParamSchema } from './types';

/**
 * Parameters of the *text layer* — how the glyphs are drawn.
 *
 * Deliberately separate from the text settings schema, which describes the geometry
 * and therefore the field every technique reads. Changing "fill vs. stroke" must not
 * invalidate the SDF; changing the tracking must.
 */
export const TEXT_LAYER_SCHEMA = [
  {
    kind: 'enum',
    key: 'renderMode',
    label: 'Modus',
    default: 'fill',
    segmented: true,
    group: 'Darstellung',
    options: [
      { value: 'fill', label: 'Füllung' },
      { value: 'stroke', label: 'Kontur' },
      { value: 'fillStroke', label: 'Beides' },
      { value: 'mask', label: 'Maske' },
    ],
    tooltip: 'Maske: der Text bleibt unsichtbar und wirkt nur als Feld für die Techniken.',
  },
  {
    kind: 'color',
    key: 'color',
    label: 'Farbe',
    default: '#f2f2f7',
    group: 'Darstellung',
    showIf: (v) => v.renderMode !== 'mask',
  },
  {
    kind: 'float',
    key: 'strokeWidth',
    label: 'Strichstärke',
    min: 0.25,
    max: 80,
    step: 0.25,
    scale: 'log',
    default: 3,
    unit: 'px',
    bulkRange: [1, 20],
    group: 'Darstellung',
    showIf: (v) => v.renderMode === 'stroke' || v.renderMode === 'fillStroke',
  },
] as const satisfies ParamSchema;

export const TEXT_LAYER_PARAMS: ParamSchema = TEXT_LAYER_SCHEMA;
